/* ******************** 
 * mapの操作
 * ********************/
import { MapStyleConfigType, MapStyleSourcesType } from "../types/components/mapStyleConfig";

 


// 特定のソースを更新
export const updateResultLabelSource = (map: maplibregl.Map, sourceId: string ,geojson: GeoJSON.FeatureCollection<GeoJSON.Geometry>) => {
    const source = map.getSource(sourceId) as maplibregl.GeoJSONSource;
    if (source) {
      source.setData(geojson);
    } else {
      console.error(`Source with id ${sourceId} does not exist.`);
    }
};

// 特定のsourceIdを持つレイヤーを取得
export const getLayersBySourceId = (map: maplibregl.Map, sourceId: string): string[] => {
    const layers = map.getStyle().layers;
    if (!layers) { return []; }
  
    return layers
        .filter(layer => layer.id.includes(sourceId))
        .map(layer => layer.id);
};



  
const isSourceIncluded = (source: string | {id: string, url: string}, newSources: MapStyleSourcesType) => {
  if (newSources.every(item => typeof item === 'string')) {
    return newSources.includes(typeof source === 'string' ? source : source.id);
  } else {
    return newSources.some(obj => obj.id === (typeof source === 'string' ? source : source.id));
  }
};


/* ******************
 * 地図スタイルの更新
 * ******************/
export const changeStyle = (mapObj: maplibregl.Map, newSources: MapStyleSourcesType, mapStyleConfig: MapStyleConfigType[]) => {
  if(!mapObj) { return; }
  const layers = mapObj.getStyle().layers;

  const otherSources = mapStyleConfig.map(config => { 
    if(config.sources.every(item => typeof item === 'string')) {
      return config.sources;
    }
    return config.sources.map(source => source.id);
  }).flat().filter(
    (source) => !isSourceIncluded(source, newSources)
  );

  if (!layers) return;

  layers.forEach(layer => {
    // 新しく選択されたレイヤーを表示
    if (newSources.some(source => layer.id.includes(typeof source === 'string' ? source : source.id))) {
      mapObj.setLayoutProperty(layer.id, 'visibility', 'visible');
    }
    if (otherSources.some(source => layer.id.includes(source))) {
      mapObj.setLayoutProperty(layer.id, 'visibility', 'none');
    }
  });
  
};
